/* global newrelic */
import { setState, getState } from '../state';

export const cartListener = () => {
  window.LIFE_CYCLE_EVENT_BUS.on('cart.add-to-cart', ({ output }) => {
    const { cartReqParams, path } = output;
    if (cartReqParams) {
      const {
        fulfillmentLocation,
        fulfillmentMethod,
        itemId,
        quantity,
      } = cartReqParams;

      window.newrelic.addPageAction('AddToCart', {
        itemId,
        quantity,
        fulfillmentMethod,
        fulfillmentLocation,
        domPath: (path || []).join('>')
      });
    }

  });

};
